import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Menu, X, Phone } from 'lucide-react';
import { Button } from './ui/button';

const Header = ({ onOpenContactForm }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    if (location.pathname !== '/') { navigate('/'); setTimeout(() => document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' }), 100); }
    else document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    setIsMobileMenuOpen(false);
  };

  const navLinks = [
    { label: 'How It Works', id: 'process' },
    { label: 'Pricing', id: 'pricing' },
    { label: 'Insights', id: 'blog' },
    { label: 'Reviews', id: 'testimonials' },
    { label: 'FAQ', id: 'faq' },
  ];

  return (
    <header data-testid="main-header" className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white/95 backdrop-blur-xl shadow-[0_2px_24px_rgba(99,102,241,0.06)] border-b border-[#EDE9FE]' : 'bg-white/70 backdrop-blur-md'}`}>
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-4">
        <div className="flex items-center justify-between">
          <button data-testid="header-logo" onClick={() => { navigate('/'); window.scrollTo({ top: 0, behavior: 'smooth' }); }} className="flex items-center gap-2 cursor-pointer group">
            <img src="/logo.png" alt="Trademark Symbol Font" className="h-10 w-auto" />
          </button>

          <nav className="hidden lg:flex items-center gap-1">
            {navLinks.map(link => (
              <button key={link.id} data-testid={`nav-${link.id}`} onClick={() => scrollToSection(link.id)} className="px-4 py-2 text-[13px] text-[#64748B] hover:text-[#6366F1] font-medium rounded-lg hover:bg-[#F5F3FF] transition-all">
                {link.label}
              </button>
            ))}
          </nav>

          <div className="hidden lg:flex items-center gap-3">
            <a href="tel:+18001234567" className="flex items-center gap-1.5 text-sm text-[#64748B] hover:text-[#6366F1] transition-colors mr-2">
              <Phone className="w-4 h-4" strokeWidth={1.5} /> +1 (800) 123-4567
            </a>
            <Button data-testid="header-cta-button" onClick={onOpenContactForm} className="btn-gradient text-white font-semibold px-6 h-10 text-sm rounded-full">
              Get Started
            </Button>
          </div>

          <button data-testid="mobile-menu-toggle" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="lg:hidden text-[#1E1B4B] p-2 hover:bg-[#F5F3FF] rounded-lg transition-colors">
            {isMobileMenuOpen ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>

        {isMobileMenuOpen && (
          <div data-testid="mobile-menu" className="lg:hidden mt-4 pb-4 border-t border-[#EDE9FE] pt-4">
            <nav className="flex flex-col gap-1">
              {navLinks.map(link => (
                <button key={link.id} data-testid={`mobile-nav-${link.id}`} onClick={() => scrollToSection(link.id)} className="text-left px-4 py-3 text-sm text-[#64748B] hover:text-[#6366F1] hover:bg-[#F5F3FF] rounded-xl transition-all">{link.label}</button>
              ))}
              <div className="pt-3 mt-2 border-t border-[#EDE9FE]">
                <Button data-testid="mobile-cta-button" onClick={onOpenContactForm} className="w-full btn-gradient text-white font-semibold h-11 rounded-full">Get Started</Button>
              </div>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
